import type { VoteEditionNomineeVotesExportResponse } from '@api/votes-api';

function escapeCsvValue(value: string): string {
  if (/[",\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function buildEditionNomineesVotesCsv(
  rows: readonly VoteEditionNomineeVotesExportResponse[],
): string {
  const lines = rows.map((row) =>
    [
      row.categoryExternalId?.toString() ?? '',
      row.dpDoctorId.toString(),
      row.name,
      row.surname ?? '',
      row.email ?? '',
      row.categoryName,
      row.isClinic ? 'true' : 'false',
      row.voteCount.toString(),
    ]
      .map(escapeCsvValue)
      .join(','),
  );

  return [
    'category_external_id,dp_doctor_id,name,surname,email,specialty,is_clinic,voteCount',
    ...lines,
  ].join('\n');
}

export function getEditionNomineesVotesCsvFilename(
  editionId: string,
  editionYear?: number,
): string {
  return editionYear != null
    ? `edition-nominees-votes-${editionYear}.csv`
    : `edition-${editionId}-nominees-votes.csv`;
}
